import mitt, { type Emitter } from 'mitt';
import type { ApplicationEvents } from '@/common/types/application-events';
declare module '#app' {
  interface NuxtApp {
    $eventBus: Emitter<ApplicationEvents>;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('eventBus', mitt());
});
